/* eslint-disable no-plusplus */
const initialVerify = (cpf) => {
  const invalid = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
  ].includes(cpf)

  return invalid === false
}

export const checkResto = (resto) => {
  if (resto === 10 || resto === 11) {
    return 0
  }
  return resto
}

export default (cpf) => {
  if (!cpf) return true
  if (cpf.length < 11) return false
  let soma = 0

  if (!initialVerify(cpf)) {
    return false
  }
  for (let i = 1; i <= 9; i++) {
    soma += Number(cpf.substring(i - 1, i), 0) * (11 - i)
  }
  let resto = (soma * 10) % 11

  if (resto === 10 || resto === 11) {
    resto = 0
  }
  if (resto !== Number(cpf.substring(9, 10), 0)) {
    return false
  }
  soma = 0
  for (let i = 1; i <= 10; i++) {
    soma += Number(cpf.substring(i - 1, i), 0) * (12 - i)
  }
  resto = (soma * 10) % 11
  resto = checkResto(resto)
  return resto === Number(cpf.substring(10, 11), 0)
}
